module.exports = __webpack_public_path__ + "img/folios--icon.26b96a71.svg";